import { CustomRoutePath, CustomRouteSegment, GroupedSegment } from '../../types/CustomRoute';

export const isSinglePointSegment = (segment: CustomRouteSegment) => {
  return segment.paths.length === 1 && segment.paths[0].points.length === 1;
};

export const isPathRoutable = (path: CustomRoutePath): boolean => {
  return path.points.length > 1;
};

export const isSegmentRoutable = (segment: CustomRouteSegment): boolean => {
  return segment.paths.length > 0 && isPathRoutable(segment.paths[0]);
};

export const isGroupedSegmentRoutable = (groupedSegment: GroupedSegment): boolean => {
  return (
    groupedSegment.pathGroups.length > 0 && groupedSegment.pathGroups[0].paths.length > 0 && isPathRoutable(groupedSegment.pathGroups[0].paths[0])
  );
};
